var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.135,
    height: 8.303,
    viewBox: "0 0 11.135 8.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M8.194,13.761l6.4-6.4a.557.557,0,0,0,0-.787l-.787-.787a.557.557,0,0,0-.787,0L7.8,11.005,5.362,8.568a.557.557,0,0,0-.787,0l-.787.787a.557.557,0,0,0,0,.787l3.619,3.619A.557.557,0,0,0,8.194,13.761Z",
    transform: "translate(-3.625 -5.621)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a6489c6ba069eebd6432f6ffd7cadc25.svg";
export { ForwardRef as ReactComponent };